import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import { styled, useTheme } from '@mui/material/styles'
import { Avatar, Box } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email';
import { useSelector } from 'react-redux'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

  const Rectangle163 = styled("Card")({
    backgroundColor: `rgba(255, 255, 255, 1)`,
    boxShadow: `0px 0px 15px rgba(0, 0, 0, 0.05)`,
    borderRadius: `34px`,
    width: '100%', 
    height: '100%', 
    margin: '0 auto', 
    padding: '16px',
    
  });

  const Card = styled("div")({
    backgroundColor: `rgba(255, 255, 255, 1)`,
    boxShadow: `0px 0px 15px 1px rgba(0, 0, 0, 0.05)`,
    borderRadius: `34px`,
    width: '100%', 
    height: '100%', 
    margin: '0 auto',
    padding: '16px',
    
  });

  const Icon = styled("img")({
    display: `flex`,
    //position: `absolute`,
    //isolation: `isolate`,
    flexDirection: `row`,
    justifyContent: `flex-start`,
    alignItems: `flex-start`,
    padding: `0px`,
    boxSizing: `border-box`,
    width: `18px`,
    height: `18px`,
  });

  /*function stringAvatar(name) {
    return {
      sx: {
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
  }*/

  

function StudentProfileCard2() {
    //const { advisorId } = useSelector((state) => state.user);
    const studentId = localStorage.getItem('studentId');
  const [ studentData, setStudentData] = useState([])
   

    useEffect(() => {
        fetch(`${API_ENDPOINT}studentdashboard/profile/${studentId}`)
        .then(res => res.json())
        .then(data => {
          setStudentData(data)
        })
    }, []);
  console.log(studentData);

  const stringAvatar = (data) => {
    if (data.image && data.image.type === 'Buffer' && data.image.data.length > 0) {
        const dataArray = data.image.data; // Get the array of numbers from the image data
        const uint8Array = new Uint8Array(dataArray); // Create a Uint8Array from the array of numbers
        const imageBlob = new Blob([uint8Array], { type: 'image/jpeg' }); // Create a Blob from the Uint8Array
        const imageUrl = URL.createObjectURL(imageBlob); 

      return {
        src: imageUrl,
        sx: {
          width: 129,
          height: 129,
        },
      };
    } else {
      return {
        sx: {
          width: 129,
          height: 129,
        },
        //children: `${data.full_name?.split(' ')[0][0]}${data.full_name?.split(' ')[1][0]}`,
      };
    }
  };

 /* if (trainerData.length === 0) {
    // If advisorData is still an empty array, show a loading or placeholder state
    return <div>No data available</div>
  }*/

  const { first_name, last_name, email, image, state, city, country, location, mobile} = studentData || {};
  return (
    
    <Card >
    <CardContent>
        <Box container spacing={2} sx={{display: 'flex'}}>
        <Box>
    <Avatar {...stringAvatar(studentData)} sx={{height: '129px', width: '129px'}}/>
    </Box>
    <Box  sx={{marginLeft: '20px'}}>
    <Typography variant='h4' sx={{color: '#000000', fontSize: '40px', fontWeight: '500', lineHeight: '28.8px'}}>Welcome</Typography>
      <Typography variant='h4' sx={{color: '#000000', fontFamily: "Inters-SemiBold, Heltivica", fontSize: '52px', fontWeight: '600'}}>{`${first_name} ${last_name}` || 'Sharon Mwenda'}</Typography>
        <Box mt={2} sx={{display: 'flex'}}>
            <Icon alt='email-icon' src={'/wetransfer_add-enquiry-svg_2023-07-25_1047/mail.svg'}></Icon>
      <Typography variant='body2' sx={{ letterSpacing: '0.25px' }}>
        {email || ''}
      </Typography>
      </Box>
      <Box sx={{display: 'flex'}} mt={2}>
            <Icon alt='call-icon' src={'/wetransfer_add-enquiry-svg_2023-07-25_1047/Phone.svg'}></Icon>
      <Typography variant='body2' sx={{ letterSpacing: '0.25px' }}>
        {mobile || ''}
      </Typography>
      </Box>
      <Box sx={{display: 'flex'}} mt={2}>
            <Icon alt='location-icon' src={'/wetransfer_add-enquiry-svg_2023-07-25_1047/Location.svg'}></Icon>
      <Typography variant='body2' sx={{ letterSpacing: '0.25px' }}>
        { `${state} ${city} ${country}` || 'Location not available'}
      </Typography>
      </Box>
      </Box>
      </Box>
    </CardContent>
  </Card>
  )
}

export default StudentProfileCard2